import * as React from "react";

import { type AgentThreadToolResultContent } from "@/shared/domain/agentThread";

import {
  detectRunPythonPayload,
  formatSeconds,
  measureRunPythonDuration,
} from "./runPythonPayload";

/** A result's `payload`, parsed: a result truncated for the model is persisted as JSON text. */
function parsePayload(payload: unknown): unknown {
  if (typeof payload !== "string") {
    return payload;
  }
  try {
    return JSON.parse(payload) as unknown;
  } catch {
    return payload;
  }
}

interface RunPythonPillLabelProps {
  toolResult: Pick<AgentThreadToolResultContent, "payload" | "runtime_ms">;
}

/**
 * A finished `run_python` call's pill text with its duration: "Ran Python · 14.3 s". The outcome
 * shows only in the card, so a failed run does not stand out in the transcript. A result without a
 * code runtime (older threads, a tool that failed, a stopped run) shows the call's total time.
 */
export function RunPythonPillLabel({
  toolResult,
}: RunPythonPillLabelProps): React.JSX.Element {
  const duration = measureRunPythonDuration({
    payload: detectRunPythonPayload(parsePayload(toolResult.payload)),
    runtimeMs: toolResult.runtime_ms,
  });
  return (
    <>
      <b>Ran Python</b> · {formatSeconds(duration.seconds)}
    </>
  );
}
